import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BACKEND_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20 * 1000, // request timeout
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
    // 'Content-Type': 'application/x-www-form-urlencoded',   // 表单提交
  },
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      config.data = config.data || {}
      config.data.token = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.error('request: ', error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (!res.success) {
      if (res.msg !== '查询失败：\u003cQuerySeter\u003e no row found') {
        Vue.prototype.error(res.msg)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.error('response: ', error) // for debug
    Vue.prototype.error(error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js